<template>
  <section class="blog-section" v-if="!loading && items.length > 0">
    <div class="text-center section-header">
      <h2 class="section-title">
        {{ $t("Blog") }}
      </h2>
      <p class="section-subtitle">
        {{ $t("Through_section") }}
      </p>
    </div>
    <div class="blog-list">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="blog-card"
        @click="singleblog(item?.id)"
      >
        <div class="blog-image-wrapper">
          <img :src="item?.image" :alt="item?.title" class="blog-image">
        </div>
        <div class="blog-content">
          <h3 class="blog-title">
            {{ item?.title }}
          </h3>
          <p class="blog-description">
            {{ item?.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
  <v-row v-else>
    <template v-if="loading">
      <v-col cols="12">
        <v-skeleton-loader
          class="mx-auto border-0"
          type="image,paragraph"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12">
        <v-skeleton-loader
          class="mx-auto border-0"
          type="image,paragraph"
        ></v-skeleton-loader>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12" class="d-flex justify-center align-center">
        <div class="no-services-card">
          <p class="no-services-text">{{ $t('no_blog_now') }}</p>
        </div>
      </v-col>
    </template>
  </v-row>
</template>

<script>
  import crudDataService from "@/Services/crudDataService";
  export default {
    data() {
      return {
        items: [],
        itemsPerRow: 3,
        loading: true,
      };
    },

    methods: {
      async blog() {
        this.loading = true;
        try {
          let response = await crudDataService.getAll(`blogs`);
          this.items = response.data.data;
        } catch (e) {
          this.items = [];
        } finally {
          this.loading = false;
        }
      },
      singleblog(id) {
        this.$router.push({ name: "SingleBlog", params: { id } });
      },
      // calculateCols(index) {
      //   const totalItems = this.items.length;

      //   const itemsInCurrentRow =
      //     index % this.itemsPerRow === 0
      //       ? this.itemsPerRow
      //       : index % this.itemsPerRow;
      //   return (
      //     Math.floor(
      //       12 / (totalItems >= this.itemsPerRow ? this.itemsPerRow : totalItems)
      //     ) * itemsInCurrentRow
      //   );
      // },
    },
    mounted() {
      this.blog();
    },
  };
</script>
<style lang="scss" scoped>
.blog-section {
  padding: 32px 0;
}

.section-header {
  margin-bottom: 40px;
}

.section-title {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: clamp(16px, 2.5vw, 20px);
  color: #666;
  font-weight: 400;
  margin: 0;
}

.blog-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.blog-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: row;
  align-items: center;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 116, 199, 0.15);
    border-color: #0074c7;
  }
}

.blog-image-wrapper {
  flex-shrink: 0;
  width: 250px;
  height: 180px;
  overflow: hidden;
  background: #f5f5f5;
  
  @media (max-width: 960px) {
    width: 200px;
    height: 150px;
  }
  
  @media (max-width: 600px) {
    width: 100%;
    height: 200px;
  }
}

.blog-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  
  .blog-card:hover & {
    transform: scale(1.05);
  }
}

.blog-content {
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  
  @media (max-width: 600px) {
    padding: 16px;
  }
}

.blog-title {
  font-size: clamp(18px, 2.5vw, 24px);
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.blog-description {
  font-size: clamp(14px, 2vw, 16px);
  color: #666;
  line-height: 1.6;
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-services-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 32px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
  border: 1px solid #e0e0e0;
}

.no-services-text {
  color: #666;
  font-size: clamp(18px, 3vw, 24px);
  font-weight: 500;
  margin: 0;
}

@media (max-width: 600px) {
  .blog-card {
    flex-direction: column;
  }
  
  .blog-section {
    padding: 24px 0;
  }
  
  .section-header {
    margin-bottom: 32px;
  }
}
</style>
